module.exports = __webpack_public_path__ + "static/media/levitate-1.e2bbe22e.mp4";